import { Engine, Scene } from '@babylonjs/core';
import { BabylonjsModuleOptions } from '@modules/babylonjs';
import { BaseEngineOptions } from '@modules/core';
import { World } from 'miniplex';

import { GraphicAPI } from './graphic';
import { RenderManager } from './manager/RenderManager';
import { Profile, setAPIEndpoint } from './util';

export type ProfileDebugInfo = {
  vertexCount: number;
  triangleCount: number;
  materialCount: number;
  textureCount: number;
}
export class StandardZed {
  public static WORLD_TOKEN: any;

  protected readonly world: World;
  protected readonly scene: Scene;
  protected readonly engine: Engine;
  protected readonly options: BaseEngineOptions & BabylonjsModuleOptions;

  constructor(
    world: World,
    scene: Scene,
    engine: Engine,
    options: BaseEngineOptions & BabylonjsModuleOptions,
    public readonly graphic: GraphicAPI,
    initAPIs: boolean = true,
    protected readonly renderManager: RenderManager
  ) {
    this.world = world;
    this.scene = scene;
    this.engine = engine;
    this.options = options;

    setAPIEndpoint(this.options.apiEndpoint ?? '/', this.options.assetsEndpoint ?? '/');

    this.initializeManagers();
    if (initAPIs) this.initializeAPIs();
  }

  protected initializeManagers() {}

  protected initializeAPIs() {}

  public getProfileDebugInfo(): ProfileDebugInfo {
    return {
      vertexCount: this.scene.getTotalVertices(),
      triangleCount: this.scene.getActiveIndices() / 3,
      materialCount: this.scene.materials.length,
      textureCount: this.scene.textures.length,
    }
  }

  public dispose() {
    Profile.reset();
    this.world.clear();
  }
}
